import { LazyQueryExecFunction, useLazyQuery } from '@apollo/client';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import {
  OAuthProvider,
  oAuthProvidersQuery,
  ReadOAuthProvidersArg,
  ReadOAuthProvidersResponse,
} from 'apis/partnerIntegrations';

type UseLazyReadOAuthProviderResponse = {
  oAuthProvider?: OAuthProvider;
  isOAuthProviderLoading: boolean;
  isOAuthProviderError: boolean;
  setOAuthProvider: Dispatch<SetStateAction<OAuthProvider | undefined>>;
  readOAuthProvider: LazyQueryExecFunction<
    ReadOAuthProvidersResponse,
    ReadOAuthProvidersArg
  >;
};

/** A hook to retrieve OAuth providers. */
export const useLazyReadOAuthProvider =
  (): UseLazyReadOAuthProviderResponse => {
    const [provider, setProvider] = useState<OAuthProvider>();

    const [
      readOAuthProvider,
      {
        data: oAuthProviderData,
        loading: isOAuthProviderLoading,
        error: oAuthProviderError,
      },
    ] = useLazyQuery<ReadOAuthProvidersResponse, ReadOAuthProvidersArg>(
      oAuthProvidersQuery,
    );

    useEffect(() => {
      if (!isOAuthProviderLoading && oAuthProviderData?.Management) {
        const newProvider = oAuthProviderData.Management.oAuthProviders[0];

        setProvider(newProvider);
      }
    }, [oAuthProviderData, isOAuthProviderLoading]);

    return {
      oAuthProvider: provider,
      isOAuthProviderLoading,
      isOAuthProviderError: !!oAuthProviderError,
      readOAuthProvider,
      setOAuthProvider: setProvider,
    };
  };
